import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitEnquiry(payload) {
  const { data } = await api.post("/enquiries", payload);
  return data;
}

export async function subscribeNewsletter(email) {
  const { data } = await api.post("/newsletter", { email });
  return data;
}
